export default "__VITE_ASSET__sTXf1OGk__"